import React from "react";
import { Card, CardActionArea, CardContent, Typography } from "@mui/material";
import CustomModal from "../../../common-utilities/core/modal";

const CreatePOChooserModal = ({ onClose, onChoosePR, onChooseIndependent }) => {
  return (
    <CustomModal
      title="Create Purchase Order"
      disabledOutsideClick={true}
      onClose={onClose}
    >
      <div className="finance-v2-po-chooser-cards">
        <Card variant="outlined" className="po-chooser-card">
          <CardActionArea onClick={onChoosePR}>
            <CardContent>
              <Typography variant="h6">Choose PR</Typography>
              <Typography variant="body2" color="text.secondary">
                Create a PO against an approved, open Purchase Requisition
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
        <Card variant="outlined" className="po-chooser-card">
          <CardActionArea onClick={onChooseIndependent}>
            <CardContent>
              <Typography variant="h6">Independent PO</Typography>
              <Typography variant="body2" color="text.secondary">
                Create a standalone PO without a linked PR
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </div>
    </CustomModal>
  );
};

export default CreatePOChooserModal;
